import React, { useEffect, useState } from "react";
import "./BodySite.css"
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import PageTitles from "./PageTitles";
import clubInfo from "../club_info.json"
import PageTitlesBig from "./PageTitlesBig";
import PageTitlesSM from "./PageTitlesSM";
import CiudadanosService from "../services/CiudadanosService";


const ActividadesIframe = () => {

    const [titulo, setTitulo] = useState("...");
    const [loading, setLoading] = useState(false);
    const [iframe, setIframe] = useState("");

    useEffect(()=>{
        setLoading(true);
        var datosLugar = clubInfo.filter((x) => { return (x.id == localStorage.getItem("Actividad-Club"))});
        
        
        var act = localStorage.getItem("Actividad-Tipo");
        if (act=="Register") {
            CiudadanosService.getDatosCiudadano(
                localStorage.getItem("hashLogin"))
                .then((resp)=>{
                    setTitulo("Registrar");
                    setIframe(datosLugar.map(x => {return x.link_inscribir})+"&nombre="+
                    resp.data.Nombre+"&apellido="+resp.data.Apellido+"&dni="+resp.data.DNI+
                    "&FecNac="+
                    resp.data.FechaNacimiento.substring(0,10)
                    +"&celular="+resp.data.Celular+"&origen=AppMiMuni"); 
                    setLoading(false)  ;     
                }
            )
            setTitulo("Registrar");
            setIframe(datosLugar.map(x => {return x.link_inscribir}));
            //setIframe("");

            
        } else if (act=="Calendar") {
            setTitulo("Calendario");
            setIframe(datosLugar.map(x => {return x.link_calendario}));
        } else  {
            setTitulo("Video");
            setIframe(datosLugar.map(x => {return x.link_video}));
        };
        setLoading(false);

    },[])
    const navigate = useNavigate();
    return (
        <>
        
      <div class="container text-center mainContent" >
        {/*<PageTitlesBig texto={titulo}  icono="./icon_header_clubes.svg" retorno="/actividaddetalle" subtexto={"Club " +localStorage.getItem("Actividad-Club")}/>*/}
        <PageTitlesSM texto={titulo}  icono="./icon_header_clubes.svg" retorno="/actividaddetalle" subtexto={"Club " +localStorage.getItem("Actividad-Club")}/> 
       { !loading?
    
    iframe!=""?
    <iframe src={iframe} class="frameContent" frameborder="0" scrolling="yes" ></iframe>:
    <>
        <div class="row"><div class="col">&nbsp;</div></div>
        <div class="row"><div class="col">&nbsp;</div></div>
        <div class="row"><div class="col">&nbsp;</div></div>

      <div class="row">
        <div class="col miniTitle">Recibimos tu solicitud.</div></div>
        <div class="row"></div>
        <div class="row"><div class="col">Nos pondremos en contacto.</div></div>
        <div class="row"><div class="col">&nbsp;</div></div>

        <div class="row">
                <div class="col">
                    <div className="buttonContainer">
                        <button className="buttonEstacionamientoClip " onClick={()=>(navigate("/actividaddetalle"))}>Volver</button>
                    </div>
                </div>
            </div>
    </>

   : <div class="col miniTitle">Cargando...</div>}
    
      </div>
        </>

    );
    }
export default ActividadesIframe;